import { trimString } from 'src/utils/helper';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

export const sendPushNotification = async ({
  link = '',
  tokens = [],
  message = '',
  imageUrl = '',
  title = CONFIG.appHostname,
  icon = `${CONFIG.appDomain}/logo/notification-192x192.png`,
}) => {
  try {
    if (tokens.length) {
      const trimStringMessage = trimString(message);
      fetch(`${CONFIG.serverUrl}/send_notifications`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: { message: trimStringMessage },
          tokens: tokens.map(({ token }) => token),
          notification: { title, body: trimStringMessage, ...(imageUrl && { imageUrl }) },
          webpush: {
            ...(link && { fcmOptions: { link } }),
            ...(icon && { notification: { icon } }),
          },
        }),
      });
    }
  } catch (error) {
    console.error('Error sending notification', error);
  }
};
